export default {
  required: 'This field is required',
  email: 'Incorrect email address',
  emailLength: 'The email address must not exceed 180 characters',
  firstNameLength: 'This field must contain between 1 and 100 characters',
  insee: 'The INSEE code must be a 5-character alphanumeric code',
  ins: 'Invalid number',
  oid: 'Invalid OID',
  phone: 'Incorrect phone number'
}
